import { render, staticRenderFns } from "./ListFeedBack.vue?vue&type=template&id=6a637694&scoped=true&"
import script from "./ListFeedBack.vue?vue&type=script&lang=js&"
export * from "./ListFeedBack.vue?vue&type=script&lang=js&"
import style0 from "./ListFeedBack.vue?vue&type=style&index=0&id=6a637694&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a637694",
  null
  
)

export default component.exports